import { View } from 'react-native';
import { Icon, Text, useTheme } from 'react-native-paper';

// Static picture of an Android notification, for the design preview only.
// Real device captures come when the Dev wires the notification channel.

export interface NotificationMockProps {
  title: string;
  body: string;
  actions: string[];
  sticky?: boolean;
  caption: string;
  status: 'new' | 'changed' | 'unchanged';
  statusLabel: string;
}

export const NotificationMock = ({ title, body, actions, sticky, caption, status, statusLabel }: NotificationMockProps) => {
  const theme = useTheme();
  const shade = theme.dark ? '#2B2D33' : '#F2F3F7';
  const statusColor =
    status === 'new' ? theme.colors.primary : status === 'changed' ? theme.colors.tertiary : theme.colors.onSurfaceVariant;
  return (
    <View style={{ gap: 6 }}>
      <View style={{ flexDirection: 'row', alignItems: 'center', gap: 8 }}>
        <Text variant="labelLarge" style={{ flex: 1, color: theme.colors.onSurface }}>
          {caption}
        </Text>
        <Text
          variant="labelSmall"
          style={{
            color: statusColor,
            borderWidth: 1,
            borderColor: statusColor,
            borderRadius: 999,
            paddingHorizontal: 8,
            paddingVertical: 2,
          }}
        >
          {statusLabel}
        </Text>
      </View>
      <View
        style={{
          backgroundColor: shade,
          borderRadius: 20,
          paddingHorizontal: 16,
          paddingTop: 12,
          paddingBottom: actions.length ? 4 : 12,
          gap: 4,
        }}
      >
        <View style={{ flexDirection: 'row', alignItems: 'center', gap: 6 }}>
          <View
            style={{
              width: 18,
              height: 18,
              borderRadius: 9,
              backgroundColor: theme.colors.primary,
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <Icon source="car" size={12} color={theme.colors.onPrimary} />
          </View>
          <Text variant="labelSmall" style={{ color: theme.colors.onSurfaceVariant }}>
            {`AllDrivers · agora${sticky ? ' · fixa' : ''}`}
          </Text>
        </View>
        <Text variant="titleSmall" style={{ color: theme.colors.onSurface, fontWeight: '700' }}>
          {title}
        </Text>
        <Text variant="bodyMedium" style={{ color: theme.colors.onSurfaceVariant }}>
          {body}
        </Text>
        {actions.length ? (
          <View style={{ flexDirection: 'row', gap: 20, paddingVertical: 8 }}>
            {actions.map((a) => (
              <Text
                key={a}
                variant="labelLarge"
                style={{ color: theme.colors.primary, fontWeight: '700', minHeight: 32, paddingVertical: 6 }}
              >
                {a}
              </Text>
            ))}
          </View>
        ) : null}
      </View>
    </View>
  );
};
